<template>
  <div id="app">
    <Presenter
      :imgRight="imgRight"
      :imgLeft="imgLeft"
      :tickets="tickets"
      :event="event"
      :loadingCustomer="loading"
      @fetchCustomers="onFetchCustomers()"></Presenter>
  </div>
</template>

<script>
import Presenter from './Presenter'
export default {
  name: 'App',

  components: {
    Presenter
  },

  data () {
    return {
      customersIds: [],
      tickets: [],
      event: {},
      loading: true,
      imgRight: '',
      imgLeft: ''
    }
  },

  computed: {
    eventId () {
      return this.$route.params.id
    },

    axiosData () {
      return {
        baseURL: `${this.db.host}/${this.db.name}/`,
        url: `/_design/tickets-by-eventId-winners/_view/tickets-by-eventId-winners?keys=["${this.eventId}"]&reduce=false&limit=50000`,
        method: 'get',
        withCredentials: true,
        auth: {
          username: this.db.user,
          password: this.db.password
        }
      }
    },

    axiosDataCostumer () {
      return {
        baseURL: `${this.db.host}/${this.db.name}/`,
        url: `/_find`,
        method: 'post',
        withCredentials: true,
        data: {
          selector: {
            '_id': {
              '$in': this.customersIds
            }
          },
          limit: 50000
        },
        auth: {
          username: this.db.user,
          password: this.db.password
        }
      }
    },

    db () {
      return {
        host: process.env.DB_HOST,
        user: process.env.DB_USER,
        password: process.env.DB_PASSWORD,
        name: process.env.DB_NAME
      }
    },

    imgsName: function () {
      return {
        left: 'imgPresenterLeft',
        right: 'imgPresenterRight'
      }
    }
  },

  methods: {
    onFetchCustomers () {
      this.fetchCustomers()
    },

    fetchCustomers () {
      this.loading = true
      this.$axios(this.axiosData)
        .then(docs => {
          let tickets = docs.data.rows.sort((a, b) => {
            if (!a.value.hasOwnProperty('rankingNow') || !b.value.hasOwnProperty('rankingNow')) return 0
            return a.value.rankingNow - b.value.rankingNow
          }).map(item => {
            this.customersIds.push(item.value.customerId)

            return item.value
          })

          this.$axios(this.axiosDataCostumer)
            .then(results => {
              console.log(results.data.docs)
              this.tickets = tickets.map(ticket => {
                ticket.customer = results.data.docs.find(customer => customer._id === ticket.customerId)
                return ticket
              })
            })
            .catch(err => console.log(err))
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.loading = false
        })
    },

    axiosGetImg (img) {
      return {
        baseURL: `${this.db.host}/${this.db.name}/`,
        url: `/config/${img}`,
        method: 'get',
        withCredentials: true,
        auth: {
          username: this.db.user,
          password: this.db.password
        }
      }
    }
  },

  created () {
    this.fetchCustomers()
  },

  mounted () {
    this.$axios(this.axiosGetImg(this.imgsName.left))
      .then(() => {
        this.imgLeft = `${this.db.host}/trg_amzn_configurations/config/${this.imgsName.left}?${new Date().getTime()}`
      })
      .catch(() => {
        this.imgLeft = require('./assets/img/amznLogo.png')
      })

    this.$axios(this.axiosGetImg(this.imgsName.right))
      .then(() => {
        this.imgRight = `${this.db.host}/trg_amzn_configurations/config/${this.imgsName.right}?${new Date().getTime()}`
      })
      .catch(() => {
        this.imgRight = require('./assets/img/amznLogo.png')
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue